import styled, { css } from "styled-components";

/**
 * The choices of the editor as a grid of tiles, each with its drawing (an icon) over its name; the chosen
 * one is outlined in the brand color. The tiles are buttons with role="radio" in a role="radiogroup": the
 * chosen one has aria-checked (or the class "selected").
 */
export const OptionTiles = styled.div<{ $columns?: number; $compact?: boolean }>`
  display: grid;
  grid-template-columns: repeat(${props => props.$columns ?? 3}, minmax(0, 1fr));
  gap: 0.5rem;

  /* under its title, where no gap of a column spaces them (the form's field screen has one) */
  p + &,
  span + & {
    margin-top: 0.75rem;
  }

  button {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    min-height: 76px;
    padding: 0.75rem 0.5rem;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1rem;
    color: var(--color-neutral-150);
    text-align: center;
    border: 1px solid var(--color-neutral-base);
    border-radius: 12px;
    transition:
      border-color 0.15s,
      color 0.15s,
      background-color 0.15s;

    &:hover {
      color: var(--color-neutral-white);
    }

    &.selected,
    &[aria-checked="true"] {
      color: var(--color-neutral-white);
      background: rgba(75, 16, 255, 0.12);
      border-color: var(--color-brand-blue);
    }
  }

  /* Smaller tiles for the choices under a type (e.g. how a selection is shown) */
  ${props =>
    props.$compact &&
    css`
      button {
        gap: 0.375rem;
        min-height: 60px;
        padding: 0.5rem 0.375rem;
        font-size: 0.6875rem;
      }
    `}
`;
